import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, useLocation, useNavigate } from 'react-router-dom';
import AppRoutes from './routes';
import LoginPage from './layout/auth';


import './App.css';
// import ForgotPasswordPage from './layout/forgotpassword';

const AppContent = ({ isAuthenticated, setIsAuthenticated }) => {
  const location = useLocation();
  const navigate = useNavigate();


  const isPublicRoute = location.pathname === '/privacypolicy' || location.pathname === '/privacypolicy.html' || 
  location.pathname === '/terms-and-condition' || location.pathname === '/terms-and-condition.html' ||
   location.pathname === '/reset-password' || location.pathname === '/reset-password.html' ||
   location.pathname === '/expire-token' || location.pathname === '/expire-token.html'
   ;

  // const isForgotPasswordRoute = location.pathname === '/forgot-password';


  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  // If it's a public route, always show the routes
  if (isPublicRoute) {
    return <AppRoutes />;
  }

  // if (isForgotPasswordRoute) {
  //   return <ForgotPasswordPage onBackToLogin={() => navigate('/')} />;
  // }

  if (!isAuthenticated) {
    return (
      <LoginPage
        onLogin={handleLogin}
        onForgotPassword={() => navigate('/reset-password')}
      />
    );
  }


  return <AppRoutes />;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check localStorage on mount to determine authentication state
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  return (
    <Router>
      <AppContent isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
    </Router>
  );
}

export default App;
